import { motion } from 'framer-motion';

const TnCTitle = () => {
  const title = 'Throw n Catch';
  const line = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 1.6,
        staggerChildren: 0.1
      }
    }
  };
  const letter = {
    hidden: {
      opacity: 0,
      y: 50
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  const svgAnimation = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.2,
        staggerChildren: 0.2
      }
    }
  };
  const svgVariants = {
    hidden: {
      opacity: 0,
      pathLength: 0
    },
    visible: {
      opacity: 1,
      pathLength: 1
    }
  };
  const svgTransition = {
    ease: 'easeInOut',
    duration: 0.6
  };
  return (
    <>
      <motion.svg
        key="tncTitleSvg"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="-293 385 24 24"
        variants={svgAnimation}
        initial="hidden"
        animate="visible"
        className="titleSvg"
      >
        <motion.circle
          fill="none"
          stroke="#f8f8f8"
          strokeWidth="2"
          cx="-278"
          cy="400"
          r="6"
          variants={svgVariants}
          transition={svgTransition}
        />
        <motion.path
          fill="none"
          stroke="#f8f8f8"
          strokeWidth="2"
          d="M-278,393.6c0,0.2,0,0.3,0,0.5c0,3.3,2.7,6,6,6c0.1,0,0.2,0,0.4,0"
          variants={svgVariants}
          transition={svgTransition}
        />
        <motion.path
          fill="none"
          stroke="#f8f8f8"
          strokeWidth="2"
          d="M-278,406c0-3.3-2.7-6-6-6c-0.1,0-0.2,0-0.3,0"
          variants={svgVariants}
          transition={svgTransition}
        />
        <motion.line
          fill="none"
          stroke="#f8f8f8"
          strokeWidth="2"
          x1="-291"
          y1="387"
          x2="-284"
          y2="394"
          variants={svgVariants}
          transition={svgTransition}
        />
        <motion.line
          fill="none"
          stroke="#f8f8f8"
          strokeWidth="2"
          x1="-285"
          y1="387"
          x2="-281"
          y2="391"
          variants={svgVariants}
          transition={svgTransition}
        />
        <motion.line
          fill="none"
          stroke="#f8f8f8"
          strokeWidth="2"
          x1="-291"
          y1="393"
          x2="-287"
          y2="397"
          variants={svgVariants}
          transition={svgTransition}
        />
      </motion.svg>
      <motion.span
        key="tncTitleText"
        variants={line}
        initial="hidden"
        animate="visible"
      >
        {title.split('').map((char, i) => (
          <motion.span key={i} variants={letter}>
            {char}
          </motion.span>
        ))}
      </motion.span>
    </>
  );
};

export default TnCTitle;
